// checkout modules
import axios from "axios";
import moment from 'moment';
import Router from '../../router'
import {
  ANYWHERE_COMMERCE_URL,
  CHECKOUT_URL,
  CHECKOUT_TOUR_URL,
  VALIDATE_DELIVERY_RADIUS_URL,
  VALIDATE_PROMO_CODE_URL,
  MOBILE_URL,
  MOBILE_SALES_ORDERS_URL,
  SHIPSTATION_API
} from "../../api/url";

export const removeToken = () => localStorage.removeItem("token");
export const getToken = () => localStorage.getItem("token");

export const handlePromoCode = (promoCode, totalPrice) => {
  let result = {};
  if (promoCode.IsPercent) {
    result.price = totalPrice / promoCode.OffRate;
  }  else {
    result.price = promoCode.OffRate;
  }
  return result;
}

const state = {
  paymentInformation: {},
  adjustedCart: {},
  selectedBillingAddress: {
    address: {},
    id: undefined
  },
  orderLoading: false,
  orderSuccessful: false,
  card_reference: null,
  timeSlots: [],
  salesOrderId: null,
  salesOrderIdConfirm: null,
  cardLoading: false,
  cardError: null,
  cardSuccess: false,
  promoCodeLoading: false,
  promoCodeSuccessful: false,
  promoCodeError: null,
  promoCodeValid: null,
  PromoCode: null,
  GrandTotal: 0,
  TotalPrice: 0,
  Savings: 0,
  windowOpening: false,
  orderFailed: false,
  orderFailMessage: null,
  IsShareCreditUsed: false,
  shipstationLoading: false,
  shipstationSuccess: false,
  shipstationError: null,
  shipstationResults: {},
};

const actions = {
  // card reference token generated from here!
  fetchACCardToken(context, card) {
    const token = localStorage.getItem("token");
    const config = {
      method: "post",
      url: ANYWHERE_COMMERCE_URL,
      data: {
        card_number: card.cardNumber,
        card_type: "VISA",
        card_holder_name: card.card_holder_name,
        card_expiry: card.expiry,
        card_cvv: card.cvc,
        sales_order_id: card.salesOrderId
      },
      headers: {
        Authorization: `JWT ${token}`
      }
    };
    context.commit('cardSubmitting');
    axios(config).then(
      response => {
        context.commit('updateACCardToken', response.data);
      },(err) => {
        context.commit('cardError', err.response)
      }
    );
  },
  
  saveCreditCard(context, card) {
    const token = localStorage.getItem("token");
    context.commit('cardSubmitting');
    if (card) {
      context.commit('updateACCardToken', card);
    } else {
      context.commit('cardError', 'error');
    }
  },

  submitOrder(context, orderData) {
    const terminal = orderData.terminal;
    const config = {
      method: "post",
      url: CHECKOUT_URL,
      data: orderData,
      headers: {
        Authorization: `JWT ${token}`
      },
    };
    config.headers = { ...config.headers };
    var withTokenConfig = { ...config };
    var token = getToken();
    if (token !== null) {
      withTokenConfig.headers.Authorization = "JWT ".concat(token);
    }
    context.commit('orderLoading');  
    axios(config)
    .then(
      response => {
        //for alipay and wechat, a new tab is opened with their respective QR codes
        if (response.data.CashierUrl) {
          if (terminal === 'ONLINE') {
            window.open(response.data.CashierUrl, '_blank');
            context.commit('orderSubmitSuccessQR', response.data);
            Router.push("/confirmation");      
          } else {
            window.open(response.data.CashierUrl, '_self');
            context.commit('orderSubmitSuccessQR', response.data);
          }
        } 
        if (!response.data.CashierUrl) {
          context.commit('orderSuccessful', response.data);
          Router.push("/confirmation");
        }
        localStorage.setItem('shareCreditUsed', false);
        context.commit('updateIsShareCreditUsed', false);
      },
      err => {
        if (err.response.status === 401) {
          removeToken();
        }
        context.commit('orderFailed', err.response.data.message);
      }
    );
  },

  async validatePromoCode(
    context,
    [promoCode, totalPrice]
  ) {
    const url = VALIDATE_PROMO_CODE_URL;
    let priceData;
    const config = {
      method: "get",
      url,
      params: {
        PromoCode: promoCode,
        TotalPrice: totalPrice
      },
      headers: {
        Authorization: `JWT ${token}`
      }
    };
    config.headers = { ...config.headers };
    var withTokenConfig = { ...config };
    var token = getToken();
    if (token !== null) {
      withTokenConfig.headers.Authorization = "JWT ".concat(token);
    }
    context.commit('promoCodeLoading');
   await axios(config).then(
      response => {
        if (response.data.is_valid) {
          priceData = handlePromoCode(response.data, totalPrice);
          priceData.PromoCode = promoCode;
          context.commit('promoCodeSuccessful', priceData);
          context.commit('updatePromoCode', priceData.price);
        } else {
          context.commit('promoCodeInvalid', response.data.message);
        }
      },
      err => {
        if (err.response.status === 401) {
          removeToken();
        }
        context.commit('promoCodeError', err);
      }
    );
  },

  fetchTimeSlots(context) {
    const url = `${MOBILE_URL}/delivery_time`;
    const token = localStorage.getItem("token");
    const config = {
      method: 'GET',
      url,
      headers: {
        Authorization: `JWT ${token}`
      }
    }
    axios(config)
    .then((response) => {
      context.commit('fetchTimeSlots', response.data);
    }, (err) => {
      console.log("fetch time slots error", err);
    })
  },
  
  fetchShipStationPrices(context, data) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'GET',
      url: SHIPSTATION_API,
      params: {
        tozip: data.tozip,
        salesOrderId: data.SalesOrder_id,
      },
      headers: {
        Authorization: `JWT ${token}`
      }
    }
    context.commit('requestShipstationLoading');
    axios(config)
    .then((response) => {
      if (Array.isArray(response.data)) {
        context.commit('shipstationSuccessful', response.data)
      } else if (response.data.ltl) {
        context.commit("b2bBypass", true)
      }
    }, (err) => {
      if (err.status === 401) {
        this.removeToken();
      }
      if (err.response.status === 400) {
        context.commit('shipstationError', err.response.data)
      } else {
        context.commit('shipstationError', err);
      }
    });
  },

  confirmSalesOrder(context, salesOrderId) {
    const token = localStorage.getItem("token");
    const dateTo = moment().add(1, 'd').format('YYYY-MM-DD');
    const dateFrom = moment().subtract(7,'d').format('YYYY-MM-DD');
    const config = {
      method: 'GET',
      url: `${MOBILE_SALES_ORDERS_URL}?OrderDate__gte=${dateFrom}&OrderDate__lte=${dateTo}`,
      headers: {
        Authorization: `JWT ${token}`
      }
    }
    axios(config)
    .then((response) => {
      let foundOrder = response.data.Orders.find(order => {
        return order.SalesOrder_id === salesOrderId
       });
        if (foundOrder) {
          context.commit('orderSuccessful');
        }
    }, (err) => {
      console.log("error in confirmation", err);
    })
  }
};

const mutations = {
  selectShippingAddress(state, payload) {
    state.selectShippingAddress = payload;
  },
  selectedBillingAddress(state, payload) {
    state.selectedBillingAddress = payload;
  },
  clearShippingAddress(state, payload) {
    state.selectedBillingAddress = payload;
  },
  clearBillingAddress(state, payload) {
    state.selectedBillingAddress = payload;
  },
  setCardToken(state, payload) {
    state.paymentInformation = payload;
  },
  adjustCart(state, payload) {
    state.adjustedCart = payload;
  },
  cardSubmitting(state, payload) {
    state.cardLoading = true;
    state.cardSuccess = false;
  },
  cardError(state, payload) {
    state.cardLoading = false;
    state.cardSuccess = false;
    state.cardError = payload.data;
  },
  updateACCardToken(state, payload) {
    state.cardLoading = false;
    state.cardSuccess = true;
    state.cardError = '';
    state.card_reference = payload;
  },
  orderFailed(state, payload) {
    state.orderLoading = false,
    state.orderSuccessful = false;
    state.orderFailed = true;
    state.orderFailMessage = payload; 
  },
  orderSuccessful(state, payload) {
    state.orderLoading = false;
    state.orderSuccessful = true;
    state.salesOrderIdConfirm = payload.SalesOrder_id;
  },
  orderLoading(state, payload) {
    state.orderLoading = true;
    state.orderSuccessful = false;
    state.orderFailed = false; 
    state.orderFailMessage = null;
  },
  fetchTimeSlots(state, payload) {
    state.timeSlots = payload;
  },
  orderSubmitSuccessQR(state, payload) {
    state.CashierUrl = payload.CashierUrl;
    state.salesOrderId = payload.SalesOrder_id;
    this.orderLoading = true;
    this.windowOpening = true;
  },
  promoCodeLoading(state, payload) {
    state.promoCodeLoading = true;
    state.promoCodeValid = '';
  },
  promoCodeSuccessful(state, payload) {
    state.promoCodeSuccessful = true;
    state.promoCodeLoading = false;
    state.PromoCode = payload.PromoCode;
    state.Savings = payload.price;
    state.promoCodeValid = '';
    state.promoCodeError = null;
  },
  promoCodeError(state, payload) {
    state.promoCodeError = payload;
    state.promoCodeLoading = false;
  },
  promoCodeInvalid(state, payload) {
    state.promoCodeLoading = false;
    state.promoCodeSuccessful = false; 
    state.promoCodeValid = payload;
  },
  setPricesForCheckout(state, payload) {
    state.GrandTotal = payload.GrandTotal;
    state.TotalPrice = payload.TotalPrice;
    state.Savings = payload.Savings;
  },
  saveTotalPrice(state, payload) {
    state.TotalPrice = payload;
  },
  updateIsShareCreditUsed(state, payload) {
    state.IsShareCreditUsed = payload;
  },
  saveGrandTotal(state, payload) {
    state.GrandTotal = payload;
  },
  clearPromoCode(state, payload) {
    state.promoCodeSuccessful = false;
    state.promoCodeLoading = false;
    state.PromoCode = null;
  },
  // this not doing anything
  clearCard(state, payload) {
    state.cardLoading = false;
    state.cardSuccess = false;
    state.card_reference = null;
  },
  clearOrderData(state, payload) {
    state.orderLoading = false; 
    state.windowOpening = false;
  },
  updatePromoCode(state, payload) {
    state.Savings = payload;
  },
  calculateGrandTotal(state, payload) {
    const GrandTotal = (payload.GrandTotal - payload.Savings).toFixed(2); 
    state.GrandTotal = GrandTotal;
  },
  requestShipstationLoading(state, payload) {
    state.shipstationLoading = true;
    state.shipstationSuccess = false; 
    state.shipstationError = null;
  },
  shipstationSuccessful(state, payload) {
    state.shipstationLoading = false;
    state.shipstationSuccess = true;
    state.shipstationResults = payload;
    state.b2bOverweight = false;
  },
  shipstationError(state, payload) {
    state.shipstationLoading = false;
    state.shipstationSuccess = false;
    state.shipstationError = payload;
  },
  resetShipstationData(state, payload) {
    state.shipstationLoading = false;
    state.shipstationSuccess = false;
    state.shipstationError = null;
    state.shipstationResults = {};
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/checkout.js